import React from 'react';

interface TypographyProps {
  children: React.ReactNode;
  className?: string;
}

// Canonical Headline Style (Based on Frame 157 + ResponsiveHeader)
export const Headline: React.FC<TypographyProps> = ({ children, className = "" }) => (
  <h1 className={`text-stone-900 text-3xl md:text-4xl font-bold font-['Test_Domaine_Display'] tracking-tight leading-tight ${className}`}>
    {children}
  </h1>
);

// Canonical Subheadline Style (Based on Frame 157)
export const SubHeadline: React.FC<TypographyProps> = ({ children, className = "" }) => (
  <p className={`text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed mb-7 ${className}`}>
    {children}
  </p>
);